import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { toastWarn } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { Box } from "@mui/material";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const UnpaidBills = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const [supplierID, setSupplierID] = useState(0);
  const [supplierValue, setsupplierValue] = useState();
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalbalance, setTotalBalance] = useState(0);
  const [agingMethod, setAgingMethod] = useState("Current");
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [classicView, setClassicView] = useState(true);
  const [suppliers, setSupplier] = useState([
    {
      Id: Number,
      CompanyName: String,
      FirstName: String,
      LastName: String,
      Email: String,
      PhoneNumber: Number,
      Address1: String,
      City: String,
      StateProvince: String,
      Zip: Number,
      Country: String,
    },
  ]);
  const [selectReport, setSelectReport] = useState(1);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const handleDropdownChange = (event) => {
    // const selectedValue = event.target.value;
    setSelectReport(event?.value);
    console.log(event.target.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };
  const handleChangeSupplier = (event) => {
    console.log(event);
    setsupplierValue(event);
    setSupplierID(event?.value);
  };

  const apicall = () => {
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/unpaidbills?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&supplierid=${supplierID}&agingmethod=${agingMethod}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            const FilterData = res.data.ResponseData?.map((el) => ({
              ...el,
              Amount: el.Amount ? el.Amount : "",
              Email: el.Email ? el.Email : "",
              Terms: el.Terms ? el.Terms : "",
              CompanyName: el.CompanyName ? el.CompanyName : "",
              Address: el.Address ? el.Address : "",
              PhoneNumber: el.PhoneNumber ? el.PhoneNumber : "",
              Memo: el.Memo ? el.Memo : "",
              OpenBalance: Number(el?.OpenBalance) || 0,
              Amount: Number(el?.Amount) || 0,
            }));

            setResponseData(FilterData);
            setRowCount(res.data.ResponseData[0].TotalRecord);
          } else {
            toastWarn("No Records Found!");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        setSupplier(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Amount);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  // to calculate the total
  const calculateTotalBalance = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.OpenBalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalBalance(sum);
  };

  useEffect(() => {
    calculateTotalSum();
    calculateTotalBalance();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Vendor",
      accessorKey: "Vendor",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Status",
      accessorKey: "status",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Date",
      accessorKey: "Date",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        const Date = moment(row.original.Date);
        if (Date.isValid()) {
          return moment(Date).format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "ReceivingsType",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            const url =
              row.original?.ReceivingsType === "Bill Payment"
                ? `/receiving-paybills/${row.original.TxnId}`
                : row.original?.ReceivingsType === "Bill" ||
                  row.original?.ReceivingsType === "Vendor Credit"
                ? `/receiving-receipt/${row.original.TxnId}`
                : row.original?.ReceivingsType === "Journal Entry"
                ? `/journal-entry/${row.original.TxnId}`
                : row.original?.ReceivingsType === "Deposit"
                ? `/bank-deposit/${row.original.TxnId}`
                : row.original?.ReceivingsType === "Expense" ||
                  row.original?.ReceivingsType === "Check" ||
                  row.original?.ReceivingsType === "Credit Card Credit"
                ? `/Expense/${row.original.TxnId}`
                : "#";

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.ReceivingsType}
        </Box>
      ),
    },
    {
      header: "NUM",
      accessorKey: "BillNo",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        const BillNo = row.original.BillNo;
        return <div>{BillNo !== "0" ? BillNo : ""}</div>;
      },
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      filterFn: "contains",
      size: "140",
      Cell: ({ row }) => {
        const DueDate = moment(row.original.DueDate);
        if (DueDate.isValid()) {
          return DueDate.format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
    {
      header: "Past due",
      accessorKey: "PastDue",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        const TotalAmount = row?.original?.Amount;

        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(TotalAmount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        const OpenBalance = parseFloat(row?.original?.OpenBalance);

        if (isNaN(OpenBalance) || OpenBalance === 0) {
          return <div style={{ textAlign: "end" }}></div>;
        } else {
          return (
            <div style={{ textAlign: "end" }}>
              {CurrencySymbols(
                Number(OpenBalance),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Created Date",
      accessor: "CreatedDate",
      filterFn: "contains",
      size: "140",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },

    {
      header: "Created By",
      accessorKey: "CreatedBy",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Email",
      accessorKey: "Email",
      filterFn: "contains",
      size: "110",
    },

    {
      header: "Terms",
      accessorKey: "Terms",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Company Name",
      accessorKey: "CompanyName",
      filterFn: "contains",
      size: "130",
    },

    {
      header: "Full Name",
      accessorKey: "FullName",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Modified Date",
      accessorKey: "ModifiedDate",
      filterFn: "contains",
      size: "140",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.ModifiedDate;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedBy",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Address",
      accessorKey: "Address",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Phone",
      accessorKey: "PhoneNumber",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Memo",
      accessorKey: "Memo",
      filterFn: "contains",
      size: "110",
    },
    // {
    //   header: "Total Record",
    //   accessorKey: "TotalRecord",
    // },
  ]);

  const Classiccolumns = [
    {
      title: "Vendor",
      field: "Vendor",
      headerFilter: "input",
      defaultVisible: true,
      frozen: true,
    },
    
    {
      title: "Date",
      field: "Date",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Transaction Type",
      field: "ReceivingsType",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const data = cell.getRow().getData();
        const span = document.createElement("span");

        span.textContent = data.ReceivingsType || "";
        span.style.borderRadius = "0.3rem";
        span.style.color = "#343f62";
        span.style.maxWidth = "18ch";
        span.style.textDecoration = "underline";
        span.style.textUnderlineOffset = "3px";
        span.style.padding = "0.3rem";
        span.style.cursor = "pointer";
        span.style.display = "flex";
        span.style.alignItems = "center";
        span.style.overflow = "hidden";
        span.style.whiteSpace = "nowrap";
        span.style.textOverflow = "ellipsis";
        span.style.fontWeight = "900";

        span.addEventListener("click", (e) => {
          e.preventDefault();
          const type = data.ReceivingsType;
          const saleId = data.TxnId;
          let url = `/Expense/${saleId}`; // default

          if (type === "Bill Payment") {
            url = `/receiving-paybills/${saleId}`;
          } else if (type === "Bill" || type === "Vendor Credit") {
            url = `/receiving-receipt/${saleId}`;
          } else if (type === "Journal Entry") {
            url = `/journal-entry/${saleId}`;
          } else if (type === "Deposit") {
            url = `/bank-deposit/${saleId}`;
          } else if (
            type === "Expense" ||
            type === "Check" ||
            type === "Credit Card Credit"
          ) {
            url = `/Expense/${saleId}`;
          }

          window.open(url, "_blank");
        });

        return span;
      },
    },

    {
      title: "Num",
      field: "BillNo",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Due Date",
      field: "DueDate",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
        {
      title: "PastDue",
      field: "PastDue",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Amount",
      field: "Amount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Open Balance",
      field: "OpenBalance",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Created Date",
      field: "CreatedDate",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Created By",
      field: "CreatedBy",
      headerFilter: "input",
      // defaultVisible: true,
    },
      {
      title: "Email",
      field: "Email",
      headerFilter: "input",
      // defaultVisible: true,
    },
      {
      title: "Terms",
      field: "Terms",
      headerFilter: "input",
      // defaultVisible: true,
      // frozen: true,
    },
   

    
    {
      title: "Company Name",
      field: "CompanyName",
      headerFilter: "input",
      // defaultVisible: true,
    },
  
    {
      title: "Full Name",
      field: "FullName",
      headerFilter: "input",
      // defaultVisible: true,
    },
     {
      title: "Modified Date",
      field: "ModifiedDate",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Last Modified By",
      field: "ModifiedBy",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Address",
      field: "Address",
      headerFilter: "input",
      // defaultVisible: true,
    },
   
   
    {
      title: "Phone",
      field: "PhoneNumber",
      headerFilter: "input",
      // defaultVisible: true,
    },

    {
      title: "Memo",
      field: "Memo",
      headerFilter: "input",
      // defaultVisible: true,
    },
    // {
    //   title: "Shipping Address",
    //   field: "DeliveryAddress",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    // },
    {
      title: "status",
      field: "status",
      headerFilter: "input",
      // defaultVisible: true,
      // frozen: true,
    },
  ];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const supplierDropDown = suppliers.map((option) => ({
    value: option.ID,
    // label: option.FirstName + " " + option.LastName,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address,
    PhoneNumber: option.PhoneNumber,
  }));

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Unpaid Bills</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                  showasofdate={true}
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Supplier
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    defaultValue={supplierValue}
                    onChange={(event) => {
                      handleChangeSupplier(event);
                    }}
                    options={supplierDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                    filterOption={(candidate, input) => {
                      const searchText = input.toLowerCase();
                      const { label, address, PhoneNumber } = candidate.data; // Access additional fields
                      return (
                        label?.toLowerCase().includes(searchText) ||
                        address?.toLowerCase().includes(searchText) ||
                        PhoneNumber?.toLowerCase().includes(searchText)
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Aging Method
              </label>
              <div className="row">
                <div className="col-6">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "Current"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "Current" : "ReportDate"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Current
                  </label>
                </div>
                <div className="col-6">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "ReportDate"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "ReportDate" : "Current"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Report Date
                  </label>
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <h6 className="fw-bold p-regular">Unpaid Bills Report</h6>
                    <div className="row mb-2">
                      {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  {ReportViewPermission == true ? (
                    <button
                      className="btn btn-secondary"
                      onClick={() => setClassicView(!classicView)}
                    >
                      {" "}
                      {classicView ? "Classic View" : "Morden View"}
                    </button>
                  ) : (
                    <></>
                  )}
                  {classicView ? (
                    <CommonTabular
                      Data={responseData}
                      columns={Classiccolumns}
                      Groupvalue={['Vendor']}
                      Reportname={"Unpaid Bills Report"}
                      frozenRowvalue={0}
                      // layout={"fitDataFill"}
                      Onrefresh={() => apicall()}
                    />
                  ) : (
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Unpaid Bill Report"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={["Vendor"]}
                      enableExpandAll={true}
                      enableExpanding={true}
                      expanded={true}
                      enableRowSelection={false}
                      columnsVisibility={{
                        CreatedDate: false,
                        CreatedBy: false,
                        Email: false,
                        Terms: false,
                        CompanyName: false,
                        FullName: false,
                        ModifiedDate: false,
                        LastModifiedBy: false,
                        Address: false,
                        PhoneNumber: false,
                        Memo: false,
                        status: false,
                      }}
                    />
                  )}
                  <div style={{ textAlign: "right" }} className=" mt-5 ">
                    <p class="text-right p-medium">
                      Total Amount:{" "}
                      {CurrencySymbols(
                        Number(totalSum),
                        { CurrencySymbol },
                        FractionDigits
                      )}
                      {/* Total Amount: ${Number(totalSum).toFixed(2)} */}
                    </p>
                    <p class="text-right p-medium">
                      Total Open Balance:{" "}
                      {CurrencySymbols(
                        Number(totalbalance),
                        { CurrencySymbol },
                        FractionDigits
                      )}
                      {/* Total Amount: ${Number(totalSum).toFixed(2)} */}
                    </p>
                    <hr
                      style={{
                        display: "inline-block",
                        borderBottom: "3px solid black",
                        width: "30%",
                      }}
                    />
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UnpaidBills;
